module.exports = __webpack_public_path__ + "img/baoz5.cd3ad7f6.png";